import { DataTypeContent } from '@efdigital/ll-addon-data/data-types';

export function getFileIcon(contentType: string) {
  if (!contentType) {
    return 'ph:file-duotone';
  }

  switch (contentType) {
    case 'image/jpeg':
    case 'image/jpg':
      return 'ph:file-jpg-duotone';
    case 'image/png':
      return 'ph:file-png-duotone';
    case 'image/gif':
      return 'ph:gif-duotone';
    case 'image/svg+xml':
      return 'ph:file-svg-duotone';
    case 'text/plain':
      return 'ph:file-text-duotone';
    case 'application/pdf':
      return 'ph:file-pdf-duotone';
    case 'application/zip':
      return 'ph:file-zip-duotone';
  }

  if (/word/i.test(contentType)) {
    return 'ph:microsoft-word-logo-duotone';
  }
  if (/excel|spreadsheet/i.test(contentType)) {
    return 'ph:microsoft-excel-logo-duotone';
  }
  if (/powerpoint|presentation/i.test(contentType)) {
    return 'ph:microsoft-powerpoint-logo-duotone';
  }

  return 'ph:file-duotone';
}

export function getFolderIcon() {
  return 'ph:folder-duotone';
}

export type TypedFileOrFolderId = {
  type: DataTypeContent.File | DataTypeContent.Folder;
  id: string;
};

export function parseTypedFileOrFolderId(
  fileOrFolderId: string
): TypedFileOrFolderId {
  const separatorIndex = fileOrFolderId.indexOf(':');
  const type = fileOrFolderId.substring(0, separatorIndex) as DataTypeContent;
  const id = fileOrFolderId.substring(separatorIndex + 1);

  if (type !== DataTypeContent.File && type !== DataTypeContent.Folder) {
    throw new Error(`Invalid item type: ${type}`);
  }

  return {
    type,
    id,
  };
}
